// extracted by mini-css-extract-plugin
export var apartmentInput = "address-invoice-fields-module--apartment-input--170f2";
export var cityInput = "address-invoice-fields-module--city-input--92548";
export var companyInput = "address-invoice-fields-module--company-input--664ca";
export var container = "address-invoice-fields-module--container--10abf";
export var houseInput = "address-invoice-fields-module--house-input--ca9b3";
export var streetInput = "address-invoice-fields-module--street-input--489d0";
export var taxInput = "address-invoice-fields-module--tax-input--2370d";
export var zipInput = "address-invoice-fields-module--zip-input--30092";